import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Table } from 'reactstrap';
import { useIntl } from 'react-intl';

import { fetchCollectedDetails } from '../../../actions/Shares';

import { APIfetchShareDetails } from '../../../api/Shares';

import CollectedDetailsListHeader from './CollectedDetailsListHeader';
import CollectedDetailsListItem from './CollectedDetailsListItem';
import CollectedDetailsFooter from './CollectedDetailsFooter';
import Loading from '../../Loading';
import ProcessingSpinner from '../../ProcessingSpinner';

import { downloadCSV } from '../../../helpers/App';
import { handleComponentParams } from '../../../helpers/URLParams';

const CollectedDetails = ({ shareUuid }) => {
  const intl = useIntl();

  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [history, setHistory] = useState([]);
  const [meta, setMeta] = useState(null);
  const [page, setPage] = useState(1);
  const [perPage] = useState(20);

  useEffect(() => {
    handleComponentParams(
      true,
      ['page'],
      null,
      [setPage],
      () => {},
    );
  }, []);

  useEffect(() => {
    setLoading(true);
    fetchCollectedDetails(shareUuid, page, perPage).then((response) => {
      setHistory(response.data);
      setMeta(response.meta);
      setLoading(false);
    });
  }, [page, perPage, shareUuid]);

  const handleDownloadCSV = () => {
    setDownloading(true);
    APIfetchShareDetails(shareUuid, { csv: true }).then((response) => {
      const fileName = response.headers['content-disposition'] || 'share-details.csv';
      return downloadCSV(response.data, fileName);
    }).finally(() => {
      setDownloading(false);
    });
  };

  const handleChangePage = (newPage) => {
    setPage(newPage);
  };

  if (loading) {
    return (
      <div className="tab-content-wrapper">
        <Loading className="gray" />
      </div>
    );
  }

  return (
    <div className="tab-content-wrapper">
      <div className="collected-details-wrapper">
        <div>
          <h4>
            {intl.formatMessage({ defaultMessage: 'Collected names and emails' })}
          </h4>
          <p>
            {intl.formatMessage({ defaultMessage: 'Browse names and emails collected on this share link' })}
          </p>
        </div>
        <div>
          <Button
            disabled={downloading}
            onClick={handleDownloadCSV}
          >
            <ProcessingSpinner show={downloading} />
            {intl.formatMessage({ defaultMessage: 'Download CSV' })}
          </Button>
        </div>
      </div>
      <div>
        {history && history.length > 0 ? (
          <>
            <div className="table-wrapper">
              <Table className="files-list collected-details-list" responsive>
                <thead>
                  <CollectedDetailsListHeader
                    downloading={downloading}
                    handleDownloadCSV={handleDownloadCSV}
                  />
                </thead>
                <tbody>
                  {history.map(element => (
                    <CollectedDetailsListItem
                      key={element.uuid}
                      element={element}
                    />
                  ))}
                </tbody>
              </Table>
            </div>
            <CollectedDetailsFooter
              total={meta ? meta.total : 0}
              page={page}
              perPage={perPage}
              handleChangePage={handleChangePage}
            />
          </>
        ) : (
          <div className="nothing-found-wrapper bottom">
            <h3>{intl.formatMessage({ defaultMessage: 'No collected details' })}</h3>
          </div>
        )}
      </div>
    </div>
  );
};

CollectedDetails.propTypes = {
  shareUuid: PropTypes.string.isRequired,
};

export default CollectedDetails;
